module.exports = __webpack_public_path__ + "img/15.8a33d195.jpg";